<template>
  <div id="home">
    <nav-bar />
    <main-content />
    <side-bar />
    <bottom-bar />
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { mapActions } from "vuex";
import NavBar from "@/components/Home/NavBar/NavBar";
import MainContent from "@/components/Home/Content/MainContent";
import SideBar from "@/components/Home/SideBar/SideBar";
import BottomBar from "@/components/Home/Footer/Footer";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "Home",

  components: { NavBar, MainContent, SideBar, BottomBar },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      isMap: true
    };
  },

  created() {
    if (this.userHasFibercloudPermission("list_list")) {
      this.GET_ALL_LISTS();
    }
    if (this.$store.getters.getAllObjectTypesProperties.length === 0) {
      this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS();
    }
  },

  mounted() {
    bus.$on("enable-sidebar", () => {
      this.isMap = true;
      this.toggleSidebar(this.isMap);
    });
    bus.$on("disable-sidebar", () => {
      this.isMap = false;
      this.toggleSidebar(this.isMap);
    });
  },

  methods: {
    ...mapActions([
      "toggleSidebar",
      "FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS",
      "RESET_HOME_STORE_MODULE_STATE",
      "GET_ALL_LISTS"
    ])
  },

  destroyed() {
    this.RESET_HOME_STORE_MODULE_STATE();
    bus.$off("enable-sidebar");
    bus.$off("disable-sidebar");
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Home.vue